import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { pushRoute } from '../../utils'
import {
  initRecoveryProcess,
  initReuploadProcess,
  completeReupload
} from '../../state/actions/stepActions'
import Page from '../../components/page'
import Header from '../../components/header'
import Wrapper from '../../components/wrapper'
import Clearfix from '../../components/clearfix'
import Title from '../../components/title'
import Widgets from '../../components/widgets'
import Button from '../../components/button'
import Footer from '../../components/footer'
import Spinner from '../../components/spinner'
import Modal from '../../components/modal'
import WebcamModal from '../../components/webcammodal'
import Result from '../../components/result'
import {ios11Instructions} from '../../utils'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

class Reupload extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { guid, step, widgets, dispatch, routing } = this.props

    if (!step.requestList || !step.contractList) {
      dispatch(initRecoveryProcess(guid, routing.flow))
    } else if (
      !!step.requestList &&
      !!step.contractList &&
      Object.keys(widgets).length === 0
    ) {
      const contract = this.props.step.contractList.find(
        c => c.azioni === 'UPLOAD'
      )
      const request = this.props.step.requestList.find(c => c.guid === guid)
      dispatch(
        initReuploadProcess(
          guid,
          contract.barCode,
          request.docType,
          request.selfie
        )
      )
    }
  }

  getSubtitle() {
    if (!!this.props.step.requestList) {
      const contract = this.props.step.requestList.find(
        r => r.guid === this.props.guid
      )
      return `${contract.prodotto} - ${contract.contactId} - ${
        contract.docType
      }`
    } else {
      return ''
    }
  }

  goBack() {
    const { routing } = this.props

    pushRoute(`/status/${!!routing.flow}`)
  }

  goForward() {
    const { guid, step, dispatch } = this.props
    const contract = step.contractList.find(c => c.azioni === 'UPLOAD')
    dispatch(completeReupload(guid, contract.barCode))
  }

  render() {
    let IOS11Rules=ios11Instructions()
    if (!this.globalStylesOverrides) {
      this.globalStylesOverrides = css(this.props.styles.globals)
    }

    if (this.props.step.isLoading) {
      return <Spinner type="global" />
    }

    if (this.props.step.hasServerErrors) {
      return (
        <Modal>
          <Result type="error">
            <div
              dangerouslySetInnerHTML={{
                __html: this.props.step.serverErrorMessage
              }}
            />
            <div dangerouslySetInnerHTML={{ __html:IOS11Rules}} />
          </Result>
        </Modal>
      )
    }

    return (
      <Page>
        {!!this.props.step.webcamComponent ? (
          <WebcamModal
            key={this.props.step.webcamComponent.name}
            component={this.props.step.webcamComponent}
          />
        ) : (
          ''
        )}
        {this.props.step.isStepLoading ? <Spinner type="step" /> : ''}
        <Header
          centeredLogo={true}
          whiteLabel={
            !!this.props.routing.locationBeforeTransitions.query.embedded
          }
        />
        <Wrapper>
          <Title title={'Reinvia il documento'} subtitle={this.getSubtitle()} />

          <Widgets
            widgets={this.props.widgets}
            components={this.props.components}
            renderNegatives={true}
            guid={this.props.guid}
          />

          <Button text="Indietro" action={this.goBack.bind(this)} />
          <Button
            text="Continua"
            action={this.goForward.bind(this)}
            type="primary"
            pullTo="right"
          />

          <Clearfix />
        </Wrapper>
        <Footer />
      </Page>
    )
  }
}

Reupload.propTypes = {
  guid: PropTypes.string,
  step: PropTypes.object.isRequired,
  widgets: PropTypes.object.isRequired,
  components: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...state,
    guid: ownProps.params.guid
  }
}

export default connect(mapStateToProps)(withStyles(Styles)(Reupload))



// WEBPACK FOOTER //
// ./containers/reupload/index.js